import { createCookieBanner } from '@wg/gdpr-cookie-banner';
import { isInGameBrowser } from './utils/utils';

if (!isInGameBrowser) {
    createCookieBanner({ initEventName: 'initCookieSettingsLink' });
}
